(function () {
  function init(root) {
    if (!root || root.dataset.dtcReady === "true") return;

    root.dataset.dtcReady = "true";

    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-dtc-toggle]");

      if (!button || !root.contains(button)) return;

      var panelId = button.getAttribute("aria-controls");
      var panel = root.querySelector("#" + panelId);

      if (!panel) return;

      var open = button.getAttribute("aria-expanded") === "true";

      button.setAttribute("aria-expanded", open ? "false" : "true");
      panel.hidden = open;
    });
  }

  function initAll(context) {
    var scope = context || document;

    scope.querySelectorAll("[data-dtc-product-details]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();